import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ServiceMessageBrokerFactory,
  ServiceMessageBroker,
} from "shared/provider-webworker";
import { IOrderAuditService, CHANNEL_AUDIT_SERVICE } from "../IOrderAuditService";
import { OrderAuditAdapter } from "../adapter/OrderAuditAdapter";
import { CubiqWorker } from "../../worker/CubiqWorker";
import { TraderGroupLookupService } from "../../lookup/model/impl/TraderGroupLookupService";
import { CoreOrderAudit } from "../../model/core/CoreOrderAudit";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class OrderAuditPrimaryService implements IOrderAuditService {
  protected broker: ServiceMessageBroker;

  constructor(
    private worker: CubiqWorker,
    protected factory: ServiceMessageBrokerFactory,
    private orderAuditAdapter: OrderAuditAdapter,
    private traderGroupService: TraderGroupLookupService,
  ) {
    this.broker = this.factory.createMessageBroker(CHANNEL_AUDIT_SERVICE, true, true);
    this.broker.registerMethod(
      "getOrderAudit",
      [PRIMITIVE, PRIMITIVE],
      this.getOrderAudit.bind(this),
      PRIMITIVE,
    );
  }

  public getOrderAudit(orderId: string, protocol: string): Promise<Array<CoreOrderAudit>> {
    let request: CubiqTS.OrderAuditLookupRequestImpl = new CubiqTS.OrderAuditLookupRequestImpl();

    request.orderId = CubiqTS.Long.fromString(orderId);
    if (protocol === "RFQ") request.protocol = CubiqTS.Protocol.RFQ;
    else if (protocol === "ORDER") request.protocol = CubiqTS.Protocol.ORDER;

    return new Promise<Array<CoreOrderAudit>>((resolve, reject) => {
      this.worker.postServiceRequest(request).then(
        (payload: any) => {
          let event: CubiqTS.StandardReportImpl = payload;
          let results: Array<CoreOrderAudit> = [];

          if (event && event.results) {
            results = event.results.map(
              this.orderAuditAdapter.transformOrderAudit.bind(this.orderAuditAdapter),
            );
            for (let i: number = 0; i < results.length; i++) {
              this.postProcessAuditRecord(results[i]);
            }
          }

          resolve(results);
        },
        (error: any) => {
          reject(error);
        },
      );
    });
  }

  protected postProcessAuditRecord(auditRecord: CoreOrderAudit): void {
    if (auditRecord.traderGroupId) {
      let id: CubiqTS.Long = CubiqTS.Long.fromString(auditRecord.traderGroupId);
      let traderGroup: CubiqTS.TradingGroupImpl = this.traderGroupService.getTraderGroup(id);
      if (traderGroup) {
        auditRecord.traderGroupName = traderGroup.groupCode;
      }
    }
  }
}
